import { store } from '@/store'
import { CommandProcessor } from './CommandProcessor'
import { BOT_DOMAIN, MEDIA_DOMAIN } from '../settings'
import { AppSettings } from '../appSettings'

export class MediaCommandProcessor {
  static async getMediaUploadUri() {
    const receiver = `${store.getters.botIdentity}@${BOT_DOMAIN}`
    const profile = AppSettings.get('MEDIA_PROFILE')

    const result = await CommandProcessor.processCommand({
      method: 'get',
      to: `postmaster@${MEDIA_DOMAIN}`,
      uri: `/upload-media-uri?secure=true&receiver=${encodeURIComponent(receiver)}&profile=${profile}`,
    })

    return result
  }

  static async getMediaUploadAuthenticatedUri() {
    const result = await CommandProcessor.processCommand({
      method: 'set',
      to: `postmaster@${MEDIA_DOMAIN}`,
      uri: '/upload-media-uri',
      type: 'application/vnd.iris.media.detail-media+json',
      resource: {
        secure: true,
        receiver: `${store.getters.botIdentity}@${BOT_DOMAIN}`,
        profile: AppSettings.get('MEDIA_PROFILE'),
      },
    })

    return result
  }

  static async refreshContentUri(uri: string) {
    const { resource } = await CommandProcessor.processCommand({
      method: 'set',
      to: `postmaster@${MEDIA_DOMAIN}`,
      uri: '/refresh-media-uri',
      type: 'text/plain',
      resource: uri,
    })

    return resource
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/api/MediaCommandProcessor.ts